import { FuseUtils } from '../../../../core/fuseUtils';
import { MatChipInputEvent } from '@angular/material';

export class Category
{
    _id: string;
    title: string;
    description: string;
    title_en: string;
    description_en: string;
    image: {
        _id: string,
        key: string,
        size: number,
        mimetype: string,
        storageType: string,
        url: string,
    };
    imageLarge: {
        _id: string,
        key: string,
        size: number,
        mimetype: string,
        storageType: string,
        url: string,
    };
    // priceTaxExcl: number;
    // priceTaxIncl: number;
    // taxRate: number;
    // comparedPrice: number;
    // quantity: number;
    // sku: string;
    // width: string;
    // height: string;
    // depth: string;
    // weight: string;
    // extraShippingFee: number;
    disabled: boolean;
    parentCategory: string;

    constructor(category?)
    {
        category = category || {};
        this._id = category._id || null; // FuseUtils.generateGUID();
        this.title = category.title || '';
        this.description = category.description || '';
        this.title_en = category.title_en || null;
        this.description_en = category.description_en || null;
        this.parentCategory = category.parentCategory || null;
        // this.tags = category.tags || [];
        this.image = category.image || null;
        this.imageLarge = category.imageLarge || null;
        this.disabled = category.disabled || false;
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/category/category.model.ts